<app-authen>
  @if(action() == ''){
  <!-- PAGE WRAPPER -->
  <div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
    <!-- RESPONSIVE CARD SHELL -->
    <div
      class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-[2rem] sm:shadow-2xl sm:border border-slate-200 relative flex flex-col"
      [class.pb-36]="totalSelectedRooms() > 0">

      <!-- ─── STICKY HEADER + SEARCH HERO ─── -->
      <div class="sticky top-0 z-30">

        <!-- TOP BAR -->
        <div
          class="bg-white/90 backdrop-blur-md shadow-sm border-b border-slate-100/60 p-3 sm:px-5 sm:rounded-t-[2rem]">
          <div class="flex items-center justify-between">
            <!-- Hotel chip -->
            <button
              class="flex items-center gap-2 rounded-xl bg-slate-50 hover:bg-slate-100 active:bg-slate-200 transition-colors px-3 py-2 border border-slate-100"
              (click)="toLocation()">
              @if (theme.logoUrl(); as logo) {
              <img [src]="logo" [alt]="theme.name()" class="w-5 h-5 rounded object-contain" />
              } @else {
              <span class="material-symbols-outlined text-blue-600" style="font-size:1.1rem">hotel</span>
              }
              <span class="text-[13px] font-bold text-slate-800 max-w-[170px] truncate">
                {{branchItem()?.name ?? ('กำลังโหลด...' | translate : 'list-room')}}
              </span>
              <span class="material-symbols-outlined text-slate-400" style="font-size:1.1rem">expand_more</span>
            </button>
            <!-- Action icons -->
            <div class="flex items-center gap-1">
              <app-language-switcher />
              @if (hasToken()) {
              <button
                class="flex items-center gap-2 rounded-xl bg-blue-50/50 hover:bg-blue-100 active:bg-blue-200 transition-colors px-3 py-2 border border-blue-100/50"
                (click)="toProfile()">
                <div class="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center shrink-0">
                  <span class="material-symbols-outlined text-white" style="font-size:0.85rem">person</span>
                </div>
                <span class="text-[11px] font-bold text-blue-700 uppercase tracking-wide">{{ 'บัญชีของฉัน' | translate : 'list-room' }}</span>
              </button>
              }
            </div>
          </div>
        </div>

        <!-- ─── SEARCH HERO ─── -->
        <div class="bg-gradient-to-br from-blue-600 to-indigo-700 px-4 py-2">
          @if (!searchHeroExpanded()) {
          <!-- Collapsed: single unified bar -->
          <div class="flex items-center gap-2">
            <div
              class="flex items-center gap-2 bg-white/15 rounded-xl px-3 py-2 flex-1 min-w-0 border border-white/10 cursor-pointer hover:bg-white/20 transition-all"
              (click)="toggleSearchHero()">
              <span class="material-symbols-outlined text-blue-200 shrink-0"
                style="font-size:1rem">calendar_month</span>
              <span class="text-[12px] font-bold text-white truncate">
                @if (checkIn() && checkOut()) {
                {{checkIn() | thaidate}} → {{checkOut() | thaidate}}
                } @else { {{ 'เลือกวันที่' | translate : 'list-room' }} }
              </span>
              <span class="text-white/30 mx-0.5">|</span>
              <span class="material-symbols-outlined text-blue-200 shrink-0" style="font-size:1rem">group</span>
              <span class="text-[12px] font-bold text-white shrink-0">{{ '{adults} คน · {rooms} ห้อง' | translate : { module: 'list-room', adults: totalAdultsAmount(), rooms: totalRoomAmount() } }}</span>
            </div>
            <button
              class="w-8 h-8 shrink-0 flex items-center justify-center rounded-xl bg-white/15 hover:bg-white/25 border border-white/10 active:scale-95 transition-all"
              (click)="toggleSearchHero()">
              <span class="material-symbols-outlined text-white" style="font-size:1.1rem">expand_more</span>
            </button>
          </div>
          }

          @if (searchHeroExpanded()) {
          <!-- Expanded: header + two separate buttons -->
          <div class="flex items-center justify-between mb-2">
            <p class="text-white/60 text-[10px] font-bold uppercase tracking-widest">{{ 'ค้นหาห้องพักที่ว่าง' | translate : 'list-room' }}</p>
            <button
              class="w-7 h-7 flex items-center justify-center rounded-lg bg-white/15 hover:bg-white/25 border border-white/10 active:scale-95 transition-all"
              (click)="toggleSearchHero()">
              <span class="material-symbols-outlined text-white" style="font-size:1rem">expand_less</span>
            </button>
          </div>
          <div class="space-y-1.5">
            <!-- Date picker trigger -->
            <button type="button"
              class="w-full bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg px-2.5 py-2 flex items-center gap-2.5 text-left transition-all active:scale-[0.98]"
              (click)="toAction('date')">
              <span class="material-symbols-outlined text-blue-200 shrink-0"
                style="font-size:1rem">calendar_month</span>
              <div class="min-w-0 flex-1">
                <div class="text-[9px] text-white/50 font-bold uppercase tracking-widest leading-none mb-0.5">
                  {{ 'วันที่เข้าพัก' | translate : 'list-room' }}</div>
                @if (checkIn() && checkOut()) {
                <div class="text-[12px] font-bold text-white truncate leading-tight">{{checkIn() | thaidate}} →
                  {{checkOut() | thaidate}}</div>
                } @else {
                <div class="text-[12px] font-bold text-white/60 leading-tight">{{ 'เลือกวันที่เช็คอิน – เช็คเอาต์' | translate : 'list-room' }}</div>
                }
              </div>
              <span class="material-symbols-outlined text-white/40 shrink-0" style="font-size:1rem">chevron_right</span>
            </button>
            <!-- Guest trigger -->
            <button type="button"
              class="w-full bg-white/10 hover:bg-white/20 border border-white/10 rounded-lg px-2.5 py-2 flex items-center gap-2.5 text-left transition-all active:scale-[0.98]"
              (click)="toAction('guest')">
              <span class="material-symbols-outlined text-blue-200 shrink-0" style="font-size:1rem">group</span>
              <div class="min-w-0 flex-1">
                <div class="text-[9px] text-white/50 font-bold uppercase tracking-widest leading-none mb-0.5">
                  {{ 'จำนวนผู้เข้าพัก' | translate : 'list-room' }}</div>
                <div class="text-[12px] font-bold text-white truncate leading-tight">
                  @if(totalAdultsAmount() > 0){{{ 'ผู้ใหญ่ {count} คน' | translate : { module: 'list-room', count: totalAdultsAmount() } }}}
                  @if(totalChildrenAmount() > 0){&nbsp;·&nbsp;{{ 'เด็ก {count} คน' | translate : { module: 'list-room', count: totalChildrenAmount() } }}}
                  @if(totalRoomAmount() > 0){&nbsp;·&nbsp;{{ '{count} ห้อง' | translate : { module: 'list-room', count: totalRoomAmount() } }}}
                </div>
              </div>
              <span class="material-symbols-outlined text-white/40 shrink-0" style="font-size:1rem">chevron_right</span>
            </button>
          </div>
          }
        </div>
        <!-- Fancy Drop Shadow Graphic under the search hero -->
        <div class="h-3 w-full bg-gradient-to-b from-black/10 to-transparent relative -z-10"></div>
      </div><!-- /sticky wrapper -->

      <!-- ─── CONTENT ─── -->
      <div class="flex-1 w-full p-4 sm:p-5 space-y-5 bg-slate-50/50">

        <!-- ── HOTEL CARD ── -->
        <div
          class="rounded-3xl bg-white border border-slate-100 overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-shadow">

          <!-- Hotel image -->
          @if (branchDetailData()?.images?.length > 0) {
          <div class="relative group cursor-pointer"
            (click)="(branchDetailData()?.images?.length ?? 0) > 1 && openGallery(branchDetailData()!.images, 0)">
            <img [src]="imgURL + branchDetailData()?.images[0].imagePath" [alt]="branchDetailData()?.name"
              (error)="$any($event.target).src='no-image.svg'"
              class="w-full aspect-[16/7] object-cover" />
            <!-- Gradient overlay -->
            <div class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            @if ((branchDetailData()?.images?.length ?? 0) > 1) {
            <div
              class="absolute bottom-4 right-4 flex items-center gap-1.5 bg-black/60 text-white text-xs px-3 py-1.5 rounded-lg backdrop-blur-md group-hover:bg-blue-600 transition-colors">
              <span class="material-symbols-outlined" style="font-size:1rem">photo_library</span>
              <span class="font-bold">+{{ '{count} รูป' | translate : { module: 'list-room', count: (branchDetailData()?.images?.length ?? 1) - 1 } }}</span>
            </div>
            }
          </div>
          }

          <div class="p-5">
            <!-- Name + rating -->
            <div class="flex items-start justify-between gap-4">
              <div class="min-w-0 flex-1">
                <h3 class="text-[18px] font-black text-slate-900 leading-snug tracking-tight">
                  {{branchDetailData()?.name ?? branchItem()?.name ?? ('กำลังโหลด...' | translate : 'list-room')}}
                </h3>
                @if (branchAddress()) {
                <div class="mt-2 flex items-start gap-1.5 text-[13px] text-slate-500">
                  <span class="material-symbols-outlined text-blue-400 shrink-0"
                    style="font-size:1.1rem">location_on</span>
                  <span class="leading-relaxed font-medium">{{branchAddress()}}</span>
                </div>
                }
              </div>
              <div
                class="shrink-0 flex items-center gap-1 rounded-xl bg-amber-50 border border-amber-200 px-3 py-1.5 shadow-sm">
                <span class="material-symbols-outlined text-amber-500" style="font-size:1.1rem">star</span>
                <span class="text-[15px] font-black text-amber-700">{{branchDetailData()?.rating ?? 5}}</span>
              </div>
            </div>

            <!-- Divider -->
            @if (getBranchFacilities().length > 0 || branchDetailData()?.detail) {
            <div class="my-4 h-px bg-slate-100"></div>
            }

            <!-- Facilities -->
            @if (getBranchFacilities().length > 0) {
            <div>
              <div class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">{{ 'สิ่งอำนวยความสะดวก' | translate : 'list-room' }}</div>
              <div class="grid grid-cols-2 gap-x-4 gap-y-2.5">
                @for (f of getDisplayedBranchFacilities(); track f.id ?? $index) {
                <div class="flex items-center gap-2 text-[13px] font-bold text-slate-700">
                  <span class="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                    <span class="material-symbols-outlined text-emerald-600" style="font-size:0.8rem">check</span>
                  </span>
                  <span class="truncate">{{f.name}}</span>
                </div>
                }
              </div>
              @if (getBranchFacilities().length > 6) {
              <button
                class="mt-3.5 text-[13px] font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 transition-colors"
                (click)="branchExpandFacilities.set(!branchExpandFacilities())">
                <span class="material-symbols-outlined" style="font-size:1rem">
                  {{branchExpandFacilities() ? 'expand_less' : 'expand_more'}}
                </span>
                {{branchExpandFacilities() ? ('ซ่อน' | translate : 'list-room') : ('ดูทั้งหมด ({count})' | translate : { module: 'list-room', count: getBranchFacilities().length })}}
              </button>
              }
            </div>
            }

            <!-- Description -->
            @if (branchDetailData()?.detail) {
            @if (getBranchFacilities().length > 0) {
            <div class="my-4 h-px bg-slate-100"></div>
            }
            <div>
              <div class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">{{ 'เกี่ยวกับเรา' | translate : 'list-room' }}</div>
              <p class="text-[13px] text-slate-600 leading-relaxed font-medium"
                [class.line-clamp-3]="!branchExpandDetail()">
                {{branchDetailData()?.detail}}
              </p>
              @if (!branchExpandDetail()) {
              <button class="mt-1.5 text-[13px] font-bold text-blue-600 hover:text-blue-700 transition-colors"
                (click)="branchExpandDetail.set(true)">{{ 'อ่านเพิ่มเติม...' | translate : 'list-room' }}</button>
              }
            </div>
            }
          </div>
        </div>

        <!-- ── ROOMS ── -->
        <div class="space-y-4">
          <div class="flex items-center gap-2 px-2 mt-2">
            <span class="material-symbols-outlined text-blue-600" style="font-size:1.25rem">bed</span>
            <h4 class="text-[17px] font-black text-slate-800 tracking-tight">{{ 'ห้องพักว่างที่แนะนำ' | translate : 'list-room' }}</h4>
          </div>

          @if (searchLoading()) {
          <!-- Skeleton loading -->
          <div class="space-y-4 pt-2">
            @for (i of [1,2]; track i) {
            <div class="rounded-3xl bg-white border border-slate-100 overflow-hidden shadow-sm animate-pulse">
              <div class="w-full aspect-[16/7] bg-slate-200"></div>
              <div class="p-5 space-y-4">
                <div class="h-5 bg-slate-200 rounded-lg w-2/3"></div>
                <div class="h-4 bg-slate-100 rounded-lg w-full"></div>
                <div class="h-4 bg-slate-100 rounded-lg w-4/5"></div>
                <div class="h-28 bg-slate-100 rounded-2xl mt-3"></div>
              </div>
            </div>
            }
          </div>
          } @else if (!hasSearched()) {
          <div
            class="rounded-3xl bg-white border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] p-8 flex flex-col items-center gap-4 text-center mt-2">
            <div class="w-16 h-16 rounded-3xl bg-blue-50 flex items-center justify-center border border-blue-100">
              <span class="material-symbols-outlined text-blue-400" style="font-size:2rem">search</span>
            </div>
            <div>
              <p class="text-base font-black text-slate-800">{{ 'กำลังเตรียมข้อมูล' | translate : 'list-room' }}</p>
              <p class="text-[13px] font-medium text-slate-500 mt-1">{{ 'กรุณารอสักครู่...' | translate : 'list-room' }}</p>
            </div>
          </div>
          } @else if (searchResults().data.length === 0) {
          <div
            class="rounded-3xl bg-white border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] p-8 flex flex-col items-center gap-4 text-center mt-2">
            <div class="w-16 h-16 rounded-3xl bg-slate-50 flex items-center justify-center border border-slate-200">
              <span class="material-symbols-outlined text-slate-400" style="font-size:2rem">hotel_class</span>
            </div>
            <div>
              <p class="text-base font-black text-slate-800">{{ 'ไม่พบห้องพักที่ว่าง' | translate : 'list-room' }}</p>
              <p class="text-[13px] font-medium text-slate-500 mt-1">{{ 'ลองเปลี่ยนวันที่หรือจำนวนผู้เข้าพัก' | translate : 'list-room' }}</p>
            </div>
          </div>
          <br><br><br>
          } @else {
          <div class="space-y-5 pt-2">
            @for (room of searchResults().data; track room.id ?? $index) {
            <div
              class="rounded-3xl bg-white border border-slate-100 overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-shadow">

              <!-- Room image -->
              @if (room.images?.length > 0) {
              <div class="relative group cursor-pointer" (click)="room.images?.length > 1 && openGallery(room.images, 0)">
                <img [src]="imgURL + room.images[0].imagePath" [alt]="room.name"
                  (error)="$any($event.target).src='no-image.svg'"
                  class="w-full aspect-[16/8] object-cover" />
                <div class="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/20 to-transparent"></div>
                <!-- Room name overlay -->
                <div class="absolute bottom-0 left-0 right-0 p-5">
                  <h5 class="text-[19px] font-black text-white drop-shadow-md tracking-tight">{{room.name}}</h5>
                  @if (room.maxCapacity > 0) {
                  <div class="mt-1 inline-flex items-center gap-1 bg-black/40 backdrop-blur-sm rounded-lg px-2 py-0.5">
                    <span class="material-symbols-outlined text-white/80" style="font-size:0.85rem">group</span>
                    <span class="text-[12px] font-bold text-white/90">{{ 'รองรับ {count} คน / ห้อง' | translate : { module: 'list-room', count: room.maxCapacity } }}</span>
                  </div>
                  }
                </div>
                @if ((room.images?.length ?? 0) > 1) {
                <div
                  class="absolute top-4 right-4 flex items-center gap-1.5 bg-black/60 text-white text-[12px] px-2.5 py-1 rounded-xl backdrop-blur-md group-hover:bg-blue-600 transition-colors">
                  <span class="material-symbols-outlined" style="font-size:1rem">photo_library</span>
                  <span class="font-bold">+{{room.images.length - 1}}</span>
                </div>
                }
              </div>
              } @else {
              <div
                class="relative w-full aspect-[16/8] bg-slate-50 flex flex-col items-center justify-center gap-2 border-b border-slate-100">
                <span class="material-symbols-outlined text-slate-300" style="font-size:3rem">meeting_room</span>
                <span class="text-[13px] text-slate-400 font-bold">{{ 'ไม่มีรูปภาพประกอบ' | translate : 'list-room' }}</span>
                <div class="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-white to-white/0">
                  <h5 class="text-[19px] font-black text-slate-800 tracking-tight">{{room.name}}</h5>
                  @if (room.maxCapacity > 0) {
                  <div class="mt-1 inline-flex items-center gap-1 bg-slate-100 rounded-lg px-2 py-0.5">
                    <span class="material-symbols-outlined text-slate-500" style="font-size:0.85rem">group</span>
                    <span class="text-[12px] font-bold text-slate-600">{{ 'รองรับ {count} คน / ห้อง' | translate : { module: 'list-room', count: room.maxCapacity } }}</span>
                  </div>
                  }
                </div>
              </div>
              }

              <div class="p-5">

                <!-- Amenities -->
                @if (getAmenities(room).length > 0) {
                <div class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">
                  {{ 'สิ่งอำนวยความสะดวกในห้อง' | translate : 'list-room' }}</div>
                <div class="grid grid-cols-2 gap-x-4 gap-y-2">
                  @for (item of getDisplayedAmenities(room); track $index) {
                  <div class="flex items-center gap-2 text-[13px] font-bold text-slate-700">
                    <span
                      class="w-5 h-5 rounded-full bg-blue-50 flex items-center justify-center shrink-0 border border-blue-100/50">
                      <span class="material-symbols-outlined text-blue-500" style="font-size:0.8rem">check</span>
                    </span>
                    <span class="truncate">{{item?.name ?? item}}</span>
                  </div>
                  }
                </div>
                @if (getAmenities(room).length > 6) {
                <button
                  class="mt-3 text-[13px] font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 transition-colors"
                  (click)="toggleAmenities(room.id)">
                  <span class="material-symbols-outlined" style="font-size:1rem">
                    {{isExpanded(room.id) ? 'expand_less' : 'expand_more'}}
                  </span>
                  {{isExpanded(room.id) ? ('ซ่อน' | translate : 'list-room') : ('ดูทั้งหมด' | translate : 'list-room')}}
                </button>
                }
                }

                <!-- Description -->
                @if (room.detail) {
                <div class="mt-4 pt-4 border-t border-slate-100/80">
                  <p class="text-[13px] text-slate-500 leading-relaxed font-medium line-clamp-2">{{room.detail}}</p>
                </div>
                }


                <!-- ── Price plans ── -->
                @if (getPricePlans(room).length > 0) {
                <div class="mt-5 pt-4 border-t border-slate-100/80">
                  <div class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">
                    {{ 'เลือกแพ็กเกจสำหรับห้องนี้' | translate : 'list-room' }}</div>
                  <div class="no-scrollbar flex gap-4 overflow-x-auto pb-2 px-1 -mx-1" appDragScroll>
                    @for (plan of getPricePlans(room); track plan.pricingModel) {
                    <div class="w-[210px] shrink-0 rounded-2xl border overflow-hidden transition-all shadow-sm" [class]="getPlanQty(room.id, plan.pricingModel) > 0
                                ? 'border-blue-500 bg-blue-50 ring-4 ring-blue-500/10'
                                : 'border-slate-200 bg-white hover:border-slate-300'">
                      <!-- Top accent bar -->
                      <div class="h-1.5 w-full" [class]="getPlanQty(room.id, plan.pricingModel) > 0
                                  ? 'bg-gradient-to-r from-blue-500 to-indigo-500'
                                  : 'bg-gradient-to-r from-slate-200 to-slate-200'">
                      </div>
                      <div class="p-4">
                        <div class="text-[13px] font-black text-slate-800 leading-snug tracking-tight">
                          {{plan.pricingModel}}</div>
                        <div class="mt-2.5 flex items-end gap-1.5">
                          <span class="text-xl font-black text-slate-900 tracking-tight">{{getPlanPrice(plan) | number}}</span>
                          <span class="text-[11px] font-bold text-slate-400 mb-1">{{ 'บาท / คืน' | translate : 'list-room' }}</span>
                        </div>

                        <!-- Available rooms badge: remaining = room.availableRooms − totalSelected -->
                        @if (getRoomMaxAvailable(room) === 0) {
                        <div class="mt-2.5 flex items-center gap-1.5">
                          <span class="w-5 h-5 rounded-full bg-red-100 flex items-center justify-center">
                            <span class="material-symbols-outlined text-red-500"
                              style="font-size:0.8rem">no_meeting_room</span>
                          </span>
                          <span class="text-[11px] text-red-600 font-bold">{{ 'ไม่มีห้องว่าง' | translate : 'list-room' }}</span>
                        </div>
                        } @else if (getRoomMaxAvailable(room) - getRoomTotalQty(room.id) > 0) {
                        <div class="mt-2.5 flex items-center gap-1.5">
                          <span class="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center">
                            <span class="material-symbols-outlined text-emerald-600"
                              style="font-size:0.8rem">meeting_room</span>
                          </span>
                          <span class="text-[11px] text-emerald-700 font-bold">{{ 'ว่าง {count} ห้อง' | translate : { module: 'list-room', count: getRoomMaxAvailable(room) - getRoomTotalQty(room.id) } }}</span>
                        </div>
                        }

                        @if (getPlanQty(room.id, plan.pricingModel) > 0) {
                        <!-- Selected state -->
                        <div class="mt-4 flex items-center gap-2">
                          <select
                            class="flex-1 h-10 rounded-xl border-2 border-blue-500 bg-white px-3 text-[14px] font-black text-blue-700 cursor-pointer focus:outline-none focus:ring-4 focus:ring-blue-500/20"
                            [ngModel]="getPlanQty(room.id, plan.pricingModel)"
                            (ngModelChange)="setPlanQty(room.id, plan.pricingModel, +$event)">
                            @for (n of getRoomOptions(room, plan); track n) {
                            <option [value]="n">{{ '{count} ห้อง' | translate : { module: 'list-room', count: n } }}</option>
                            }
                          </select>
                          <button
                            class="w-10 h-10 grid place-items-center rounded-xl border border-red-200 bg-red-50 text-red-500 hover:bg-red-100 hover:text-red-600 active:scale-95 transition-all"
                            (click)="removePlan(room.id, plan.pricingModel)">
                            <span class="material-symbols-outlined" style="font-size:1.1rem">delete</span>
                          </button>
                        </div>
                        } @else {
                        <!-- Default state: disable เมื่อ room ไม่มีห้องว่างเหลือ หรือเกิน capacity -->
                        @let roomFull = getRoomTotalQty(room.id) >= getRoomMaxAvailable(room);

                        <button class="mt-4 w-full h-10 rounded-xl text-[13px] font-black transition-all border"
                          [class]="(roomFull)
                                      ? 'bg-slate-100 text-slate-400 cursor-not-allowed border-slate-100'
                                      : 'bg-white text-slate-800 hover:bg-slate-50 hover:border-slate-300 active:scale-95 cursor-pointer shadow-sm border-slate-200'"
                          [disabled]="roomFull"
                          (click)="!roomFull  && selectPlan(room.id, plan.pricingModel, getPlanPrice(plan))">
                          {{ roomFull ? ('ห้องเต็ม' | translate : 'list-room') : ('เพิ่มแพ็กเกจนี้' | translate : 'list-room') }}
                        </button>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }

              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>
    </div>

    <!-- ─── STICKY BOTTOM BAR ─── -->
    @if (totalSelectedRooms() > 0) {
    <div
      class="fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-t border-slate-100 shadow-[0_-10px_30px_rgba(0,0,0,0.06)] flex justify-center pb-safe">
      <div class="w-full max-w-md sm:max-w-xl lg:max-w-2xl px-5 py-4">
        <!-- Capacity warning -->
        @if (!guestCapacityMet()) {
        <div class="mb-3 flex items-center gap-2.5 rounded-xl bg-amber-50 border border-amber-200 px-4 py-2.5">
          <span class="material-symbols-outlined text-amber-500 shrink-0" style="font-size:1.1rem">warning</span>
          <span class="text-[12px] font-bold text-amber-700 leading-tight">
            {{ 'กรุณาเลือกห้องให้รองรับผู้เข้าพักครบ {total} คน (รองรับได้ {capacity} / {total} คน)' | translate : { module: 'list-room', total: totalAdultsAmount() + totalChildrenAmount(), capacity: totalSelectedCapacity() } }}
          </span>
        </div>
        }
        <!-- Proceed button with summary inside -->
        <button class="w-full rounded-2xl px-4 py-3 text-white flex items-center justify-between gap-3 transition-all"
          [class]="guestCapacityMet()
            ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98] shadow-lg shadow-blue-500/30 cursor-pointer'
            : 'bg-slate-300 cursor-not-allowed'" [disabled]="!guestCapacityMet()"
          (click)="guestCapacityMet() && toNextStep()">
          <div class="text-left">
            <div class="text-[10px] font-semibold text-white/70 leading-none mb-0.5">
              {{ '{rooms} ห้อง · รวม {nights} คืน' | translate : { module: 'list-room', rooms: totalSelectedRooms(), nights: totalNights() } }}
            </div>
            <div class="text-[17px] font-black tracking-tight leading-tight">
              {{totalSelectedPrice() | number}} <span class="text-[12px] font-bold text-white/80">{{ 'บาท' | translate : 'list-room' }}</span>
            </div>
          </div>
          <div class="flex items-center gap-1 text-[14px] font-bold shrink-0">
            {{ 'ดำเนินการต่อ' | translate : 'list-room' }}
            <span class="material-symbols-outlined text-[18px]">arrow_forward</span>
          </div>
        </button>
      </div>
    </div>
    }

  </div>
  }

  @if (action() === 'date') {
  <div>
    <app-checkin [inputDate]="[checkIn(),checkOut()]" (updateDate)="updateDate($event)"></app-checkin>
  </div>
  }
  <div [ngClass]="{'hidden': action() != 'guest'}">
    <app-select-guest-room [inputModel]="guestModel()" (updateItems)="updateGuest($event)"></app-select-guest-room>
  </div>

<!-- ─── GALLERY LIGHTBOX ─── -->
@if (galleryOpen()) {
<div class="fixed inset-0 z-[100] bg-black/95 flex flex-col" (click)="closeGallery()">
  <!-- Header -->
  <div class="flex items-center justify-between px-4 py-3 shrink-0" (click)="$event.stopPropagation()">
    <span class="text-white/60 text-[13px] font-bold">{{galleryIndex() + 1}} / {{galleryImages().length}}</span>
    <button class="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
      (click)="closeGallery()">
      <span class="material-symbols-outlined text-white" style="font-size:1.2rem">close</span>
    </button>
  </div>

  <!-- Image -->
  <div class="flex-1 flex items-center justify-center px-4 relative" (click)="$event.stopPropagation()">
    <img [src]="imgURL + galleryImages()[galleryIndex()].imagePath"
      (error)="$any($event.target).src='no-image.svg'"
      class="max-h-full max-w-full object-contain rounded-xl select-none" />

    <!-- Prev -->
    @if (galleryImages().length > 1) {
    <button class="absolute left-2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center transition-colors"
      (click)="prevImage()">
      <span class="material-symbols-outlined text-white">chevron_left</span>
    </button>
    <!-- Next -->
    <button class="absolute right-2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center transition-colors"
      (click)="nextImage()">
      <span class="material-symbols-outlined text-white">chevron_right</span>
    </button>
    }
  </div>

  <!-- Thumbnails -->
  @if (galleryImages().length > 1) {
  <div class="flex gap-2 px-4 py-3 overflow-x-auto shrink-0 justify-center" (click)="$event.stopPropagation()">
    @for (img of galleryImages(); track $index) {
    <button (click)="galleryIndex.set($index)"
      class="shrink-0 w-14 h-14 rounded-lg overflow-hidden border-2 transition-all"
      [class]="galleryIndex() === $index ? 'border-white opacity-100' : 'border-transparent opacity-50'">
      <img [src]="imgURL + img.imagePath" (error)="$any($event.target).src='no-image.svg'" class="w-full h-full object-cover" />
    </button>
    }
  </div>
  }
</div>
}

</app-authen>